module.exports = "<div class=\"container\">\r\n    &copy; 2024 - Catholic Schools NSW - Version {{version}}\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared/footer/footer.component.html
// module id = 510
// module chunks = 0